import axios from 'axios'
import NProgress from 'nprogress'
import {
    getToken,
    setToken,
    getRefreshToken,
    setRefreshToken
} from '../util/auth'
import router from '@/router'
import {
    Notify
} from 'vant'
async function refresh(token, refreshToken) {
    return await axios({
        url: '/api/auth/refresh',
        method: "post",
        data: {
            token,
            refreshToken
        },
        meta: {
            isToken: false
        }
    });
}
async function asyncAxios(config) {
    return await axios(config);
}
const instance = axios.create();
instance.defaults.timeout = 10000;
//返回其他状态吗
instance.defaults.validateStatus = function (status) {
    return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
instance.defaults.withCredentials = true;
// NProgress Configuration
NProgress.configure({
    showSpinner: false
});
//HTTPrequest拦截
instance.interceptors.request.use(config => {
    NProgress.start() // start progress bar
    let token = getToken();
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    } else {
        const meta = (config.meta || {});
        const isNotToken = meta.isToken === false;
        if (!isNotToken) {
            router.push({
                path: '/login'
            });
            return Promise.reject(new Error('needlogin'));
        }
    }

    return config
}, error => {
    return Promise.reject(error)
});
//HTTPresponse拦截
instance.interceptors.response.use(async res => {
    NProgress.done();
    if (res.status == 200) {
        if (res.data.code && res.data.code != "SUCCESS") {
            const msg = res.data.msg;
            Notify({
                type: 'danger',
                message: msg
            });
            return Promise.reject(new Error(msg));
        }
        return res;
    } else {
        //如果是401则跳转到登录页面
        if (res.status === 401) {
            let refreshToken = getRefreshToken();
            if (refreshToken) {
                var dto = await refresh(getToken(), refreshToken);
                if (dto.data.code == "SUCCESS") {
                    setToken(dto.data.value.token);
                    setRefreshToken(dto.data.value.refreshToken);
                    res.config.headers['Authorization'] = 'Bearer ' + dto.data.value.token;
                    res = await asyncAxios(res.config);
                    return res;
                }
            }
            router.push({
                path: '/login'
            })
        } else {
            // 如果请求为非200否者默认统一处理
            Notify({
                type: 'danger',
                message: '未知错误'
            });
            return Promise.reject(new Error('未知错误'))
        }
    }
}, error => {
    NProgress.done();
    return Promise.reject(new Error(error));
})

export default instance;